"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageTitle = exports.GridRow = exports.GridCell = exports.Spacer = exports.Grid = exports.Box = exports.Layout = exports.LayoutContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = require("./theme");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _globalstyles = require("./globalstyles");

require("./fontello/css/flexibull-2-0.css");

require("./fontello/css/animation.css");

require("./fonts/fonts.css");

var _navigation = require("./navigation");

var _typo = require("./typo");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PageWrapper = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-layout',
  id: 'flexi-layout'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-width: 100vw;\n  min-height: 100vh;\n  font-family: ", ";\n  font-size: ", ";\n  transition: padding 0.3s ease-out;\n  position: relative;\n  ", "\n  ", "\n"])), function (props) {
  return props.theme.PrimaryFont;
}, function (props) {
  return props.theme.PrimaryFontSize;
}, function (props) {
  return props.withSideNav && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      padding-left: ", ";\n      ", "\n      ", "\n    "])), props.openWidth, props.collapseSide && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          padding-left: ", ";\n        "])), props.closeWidth), props.floatSideNav && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          padding-left: 0;\n        "]))));
}, function (props) {
  return props.withTopNav && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
});

var LayoutContext = /*#__PURE__*/_react["default"].createContext();

exports.LayoutContext = LayoutContext;

var Layout = function Layout(props) {
  var theme = _objectSpread({}, _theme.FlexTheme);

  props.theme && (theme = _objectSpread(_objectSpread({}, _theme.FlexTheme), props.theme));
  var node = (0, _react.useRef)();

  var _useState = (0, _react.useState)({
    collapseSide: props.sideNavProps && props.sideNavProps["float"] ? true : false,
    floatSide: props.sideNavProps && props.sideNavProps["float"]
  }),
      _useState2 = _slicedToArray(_useState, 2),
      layoutVar = _useState2[0],
      setLayoutVar = _useState2[1];

  var _useState3 = (0, _react.useState)({
    themeColor: false,
    title: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      pageVar = _useState4[0],
      setPageVar = _useState4[1];

  var setLayout = function setLayout(elem) {
    setLayoutVar(_objectSpread(_objectSpread({}, layoutVar), elem));
  };

  var setPage = function setPage(elem) {
    setPageVar(function (prevProps) {
      return _objectSpread(_objectSpread({}, prevProps), elem);
    });
  };

  var handleResize = function handleResize() {
    node.current.clientWidth < 600 ? setLayout({
      floatSide: true,
      collapseSide: true
    }) : setLayout({
      floatSide: false,
      collapseSide: false
    });
  };

  (0, _react.useEffect)(function () {
    if (props.sideNavProps && !props.sideNavProps["float"]) {
      window.addEventListener('resize', handleResize);
      window.addEventListener('load', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('load', handleResize);
      };
    }
  }, [node]);
  return /*#__PURE__*/_react["default"].createElement(LayoutContext.Provider, {
    value: {
      layoutVar: layoutVar,
      setLayout: setLayout,
      setPage: setPage
    }
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: pageVar.themeColor ? _objectSpread(_objectSpread({}, theme), {
      PrimaryColor: pageVar.themeColor
    }) : theme
  }, /*#__PURE__*/_react["default"].createElement(_globalstyles.Global, null), /*#__PURE__*/_react["default"].createElement(PageWrapper, {
    ref: node,
    withSideNav: props.withSideNav,
    withTopNav: props.withTopNav,
    floatSideNav: layoutVar.floatSide,
    collapseSide: layoutVar.collapseSide,
    openWidth: props.sideNavOpenWidth,
    closeWidth: props.sideNavCloseWidth
  }, props.withTopNav && /*#__PURE__*/_react["default"].createElement(_navigation.TopBar, _extends({}, props.topNavProps, {
    height: props.topNavHeight,
    title: pageVar.title,
    collapseIcon: props.collapseIcon,
    expandIcon: props.expandIcon,
    spaceLeft: props.withSideNav && !layoutVar.floatSide ? layoutVar.collapseSide ? props.sideNavCloseWidth : props.sideNavOpenWidth : '0',
    toogle: props.withSideNav
  }), props.topNavContent), props.withSideNav && /*#__PURE__*/_react["default"].createElement(_navigation.SideBar, _extends({
    collapse: layoutVar.collapseSide
  }, props.sideNavProps, {
    "float": layoutVar.floatSide,
    openWidth: props.sideNavOpenWidth,
    closeWidth: props.sideNavCloseWidth,
    brandHeight: props.topNavHeight
  }), props.sideNavContent), props.children)));
};

exports.Layout = Layout;

var Box = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", "\n      ", "\n    ", "\n    ", "\n    ", "\n    margin: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    padding: ", ";\n    ", "\n"])), function (props) {
  return props.width && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        width: ", ";\n      "])), function (props) {
    return props.width;
  });
}, function (props) {
  return props.background && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), props.background);
}, function (props) {
  return props.maxWidth && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        max-width: ", ";\n      "])), function (props) {
    return props.maxWidth;
  });
}, function (props) {
  return props.height && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        height: ", ";\n      "])), function (props) {
    return props.height;
  });
}, function (props) {
  return props.maxHeight && (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        max-height: ", ";\n      "])), function (props) {
    return props.maxHeight;
  });
}, function (props) {
  return props.margin;
}, function (props) {
  return props.centered && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        margin: 0 auto;\n      "])));
}, function (props) {
  return props.display && (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n        display: ", ";\n      "])), function (props) {
    return props.display;
  });
}, function (props) {
  return props.align && (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        text-align: ", ";\n      "])), function (props) {
    return props.align;
  });
}, function (props) {
  return props.relative && (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n        position: relative;\n      "])));
}, function (props) {
  return props.fullHeight && (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n        height: 100%;\n      "])));
}, function (props) {
  return props.vAlign && (0, _styledComponents.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n        display: flex;\n        align-items: center;\n      "])));
}, function (props) {
  return props.pad;
}, function (props) {
  return props.round && (0, _styledComponents.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n      "])), function (props) {
    return props.round === 'high' ? props.theme.SecondaryRadius : props.theme.PrimaryRadius;
  });
});

exports.Box = Box;
var Grid = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-grid'
})(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  display: ", ";\n  grid-template-columns: ", ";\n  ", "\n\n  grid-template-rows: ", ";\n\n  ", "\n\n  ", "\n    ", "\n  ", "\n  \n  ", "\n\n  "])), function (props) {
  return props.inline ? 'inline-grid' : 'grid';
}, function (props) {
  return props["default"];
}, function (props) {
  return props.responsive && (0, _styledComponents.css)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), _theme.media.large(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n      grid-template-columns: ", ";\n    "])), function (props) {
    return props["default"];
  }), _theme.media.desktop(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n      grid-template-columns: ", ";\n    "])), function (props) {
    return props.lr;
  }), _theme.media.tablet(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n      grid-template-columns: ", ";\n    "])), function (props) {
    return props.md;
  }), _theme.media.phone(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n      grid-template-columns: ", ";\n    "])), function (props) {
    return props.sm;
  }));
}, function (props) {
  return props.templateRow;
}, function (props) {
  return props.margin && (0, _styledComponents.css)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n      margin: ", ";\n    "])), function (props) {
    return props.margin;
  });
}, function (props) {
  return props.gap && (0, _styledComponents.css)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n      grid-gap: ", ";\n    "])), function (props) {
    return props.gap;
  });
}, function (props) {
  return props.columnGap && (0, _styledComponents.css)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n        column-gap: ", ";\n      "])), function (props) {
    return props.columnGap;
  });
}, function (props) {
  return props.rowGap && (0, _styledComponents.css)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n      row-gap: ", ";\n    "])), function (props) {
    return props.rowGap;
  });
}, function (props) {
  return props.alignItems && (0, _styledComponents.css)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n      align-items: ", ";\n    "])), function (props) {
    return props.alignItems;
  });
});
exports.Grid = Grid;

var Spacer = _styledComponents["default"].span(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  display: ", ";\n  height: ", "px;\n  width: ", "px;\n"])), function (props) {
  return props.inline ? 'inline-block' : 'block';
}, function (props) {
  return ['vertical', 'both'].includes(props.direction) && parseInt(props.space);
}, function (props) {
  return ['horizontal', 'both'].includes(props.direction) && parseInt(props.space);
});

exports.Spacer = Spacer;
Spacer.defaultProps = {
  space: '10px',
  direction: 'vertical',
  inline: false
};
Spacer.propTypes = {
  space: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  direction: _propTypes["default"].string,
  inline: _propTypes["default"].bool
};

var GridRowWrapper = _styledComponents["default"].div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  display: ", ";\n  ", "\n    ", "\n  ", "\n  \n  ", "\n\n    ", "\n"])), function (props) {
  return props.inline ? 'inline-grid' : 'grid';
}, function (props) {
  return props.gap && (0, _styledComponents.css)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n      grid-gap: ", ";\n    "])), function (props) {
    return props.gap;
  });
}, function (props) {
  return props.columnGap && (0, _styledComponents.css)(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n        column-gap: ", ";\n      "])), function (props) {
    return props.columnGap;
  });
}, function (props) {
  return props.rowGap && (0, _styledComponents.css)(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n      row-gap: ", ";\n    "])), function (props) {
    return props.rowGap;
  });
}, function (props) {
  return props.alignItems && (0, _styledComponents.css)(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n      align-items: ", ";\n    "])), function (props) {
    return props.alignItems;
  });
}, function (props) {
  return props.margin && (0, _styledComponents.css)(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n        margin: ", ";\n      "])), function (props) {
    return props.margin;
  });
});

var GridCell = (0, _styledComponents["default"])(Box)(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  grid-column-end: span ", ";\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.span;
}, _theme.media.desktop(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n      grid-column-end: span ", ";\n  "])), function (props) {
  return props.lr;
}), _theme.media.tablet(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n      grid-column-end: span ", ";\n  "])), function (props) {
  return props.md;
}), _theme.media.phone(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n      grid-column-end: span ", ";\n  "])), function (props) {
  return props.sm;
}));
exports.GridCell = GridCell;

var GridRow = function GridRow(props) {
  var myChildren = [];

  if (props.children) {
    myChildren = !Array.isArray(props.children) ? [props.children] : props.children;
  }

  (0, _react.useEffect)(function () {
    myChildren = !Array.isArray(props.children) ? [props.children] : props.children;
  }, [props.children]);
  var keyGen = new Date().getTime();
  return /*#__PURE__*/_react["default"].createElement(GridRowWrapper, props, props.children && myChildren.map(function (elem, index) {
    return /*#__PURE__*/_react["default"].createElement(GridCell, _extends({
      key: "grid-item-".concat(index, "-").concat(keyGen)
    }, elem.props), elem.props.children && elem.props.children);
  }));
};

exports.GridRow = GridRow;
GridRow.defaultProps = {
  inline: false,
  gap: '10px',
  alignItems: 'stretch'
};
GridRow.propTypes = {
  inline: _propTypes["default"].bool,
  gap: _propTypes["default"].string,
  columnGap: _propTypes["default"].string,
  rowGap: _propTypes["default"].string,
  alignItems: _propTypes["default"].string
};
Grid.defaultProps = {
  inline: false,
  "default": 'repeat(6, 1fr)',
  lr: 'repeat(3, 1fr)',
  md: 'repeat(2, 1fr)',
  sm: '1fr',
  gap: '10px',
  alignItems: 'stretch',
  responsive: true
};
Grid.propTypes = {
  inline: _propTypes["default"].bool,
  "default": _propTypes["default"].string,
  sm: _propTypes["default"].string,
  lr: _propTypes["default"].string,
  md: _propTypes["default"].string,
  gap: _propTypes["default"].string,
  gridGap: _propTypes["default"].string,
  columnGap: _propTypes["default"].string,
  rowGap: _propTypes["default"].string,
  templateRow: _propTypes["default"].string,
  alignItems: _propTypes["default"].string,
  responsize: _propTypes["default"].bool
};
Layout.defaultProps = {
  withSideNav: false,
  withTopNav: false,
  sideNavOpenWidth: '200px',
  sideNavCloseWidth: '60px',
  topNavHeight: '80px'
};
Layout.propTypes = {
  theme: _propTypes["default"].any,
  withSideNav: _propTypes["default"].bool,
  withTopNav: _propTypes["default"].bool,
  sideNavOpenWidth: _propTypes["default"].string,
  sideNavCloseWidth: _propTypes["default"].string,
  sideNavProps: _propTypes["default"].any,
  topNavProps: _propTypes["default"].any,
  sideNavContent: _propTypes["default"].any,
  collapseIcon: _propTypes["default"].string,
  expandIcon: _propTypes["default"].string
};
Box.defaultProps = {
  pad: 0,
  margin: 0
};
Box.propTypes = {
  width: _propTypes["default"].string,
  maxWidth: _propTypes["default"].string,
  height: _propTypes["default"].string,
  maxHeight: _propTypes["default"].string,
  centered: _propTypes["default"].bool,
  display: _propTypes["default"].string,
  relative: _propTypes["default"].bool,
  fullHeight: _propTypes["default"].bool,
  align: _propTypes["default"].string,
  padding: _propTypes["default"].any,
  margin: _propTypes["default"].any,
  vAlign: _propTypes["default"].bool,
  progress: _propTypes["default"].bool,
  background: _propTypes["default"].string,
  round: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool])
};

var PageTitle = function PageTitle(props) {
  var children = props.children;

  var _useContext = (0, _react.useContext)(LayoutContext),
      setPage = _useContext.setPage;

  var setLayoutCallback = (0, _react.useCallback)(function (props) {
    return setPage(props);
  }, []);
  (0, _react.useEffect)(function () {
    setLayoutCallback({
      title: /*#__PURE__*/_react["default"].createElement(_typo.Text, {
        block: true,
        size: "22px"
      }, children && children)
    });
  }, [children, setLayoutCallback]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, null);
};

exports.PageTitle = PageTitle;